import classnames from 'classnames'
import PropTypes from 'prop-types'
import React, { useRef } from 'react'

import routes from '../../router/routes'
import { getScrollTop } from '../../utils/LayoutUtils'
import { chainDecorators, memoized } from '../../utils/ReactUtils'
import ImageStatic from '../ImageStatic'
import Link from '../Link'
import ResizeWatcher from '../ResizeWatcher'
import ScrollWatcher from '../ScrollWatcher'

import styles from './styles'
import router from '../../router'


const decorators = [
  memoized,
]

function Header(props) {
  const { buttonLabel, locale, onClickButton, t } = props

  const [barTop, setBarTop] = React.useState(0)
  const [blurHeader, setBlurHeader] = React.useState(false)

  const barRef = useRef(null)
  const barHeight = useRef(0)
  const scrollTop = useRef(getScrollTop())

  function handleScroll(scrollTopValue) {
    const barLimit = barHeight.current + 10
    const currentScrollTop = scrollTop.current
    const nextScrollTop = scrollTopValue
    const diff = currentScrollTop - nextScrollTop
    const clampedBarTop = Math.min(0, Math.max(barTop + diff, -barLimit))
    scrollTop.current = nextScrollTop

    setBarTop(scrollTopValue >= 100 ? clampedBarTop : 0)
    setBlurHeader(scrollTopValue >= 100 ? nextScrollTop !== -clampedBarTop : false)
  }

  function handleLayout() {
    barHeight.current = barRef.current.clientHeight
    handleScroll(scrollTop.current)
  }

  function handleBarRef(ref) {
    if (!ref) {
      return
    }
    barRef.current = ref
    handleLayout()
  }

  function handleClickButton() {
    onClickButton()
  }

  return (
    <header
      ref={handleBarRef}
      className={classnames('container', blurHeader && 'blur')}
      style={{ top: `${barTop}px` }}
    >
      <div className="inner">
        <aside>
          <Link route={routes.home.path} routeParams={{ locale }}>
            <ImageStatic
              className="logo"
              width={40}
              height={30}
              src="/images/logos/logo-white.svg"
            />
          </Link>
        </aside>
        <div className="right">
          <Link className="link" route={routes.contact.path} routeParams={{ locale }}>
            <span className="label">{t('menuContact')}</span>
          </Link>
          <a
            role="button"
            tabIndex={0}
            href="javascript:void(0);"
            className="link"
            onTouchEnd={handleClickButton}
            onClick={handleClickButton}
          >
            <span className="label">{t('menuLabel').toUpperCase()}</span>
          </a>
        </div>
      </div>
      <ResizeWatcher onChange={handleLayout} />
      <ScrollWatcher onChange={handleScroll} />
      <style jsx>{styles}</style>
    </header>
  )
}

Header.propTypes = {
  onClickButton: PropTypes.func,
  buttonLabel: PropTypes.string,
  locale: PropTypes.string,
  t: PropTypes.func,
}

Header.defaultProps = {
  onClickButton: () => null,
  buttonLabel: '',
  locale: undefined,
  t: () => null,
}

Header = chainDecorators(decorators, Header)

export default Header
